<div class="button-list">
  <!-- Button that triggers the menu -->
  <button
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
    class="release-btn btn-accello-secondary"
    *ngIf="!isHeaderComponent"
  >
    <img
      [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
      alt="Add Icon"
      width="18"
      height="18"
    />
    <span>Add New Parameter</span>
    <mat-icon class="arrow-icon">
      {{ menuTrigger?.menuOpen ? "expand_less" : "expand_more" }}
    </mat-icon>
  </button>

  <mat-menu #menu="matMenu" class="custom-menu">
    <button mat-menu-item (click)="addNewRequestParam()" class="general-text">
      New Request Parameter
    </button>
    <button mat-menu-item (click)="addNewPayloadParam()" class="general-text">
      New Payload Parameter
    </button>
  </mat-menu>

  <button
    class="release-btn btn-accello-secondary"
    (click)="addNewHeader()"
    *ngIf="isHeaderComponent"
  >
    <img
      [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
      alt="Add Icon"
      width="18"
      height="18"
    />
    Add New Header
  </button>

  <button *ngIf="isHeaderComponent"
  class="release-btn btn-accello-light"
  (click)="removeHeaders()"
  [disabled]="!selectedHeaders.length"
  (focus)="changeRemoveIcon(false)"
  (mouseenter)="changeRemoveIcon(false)"
  (mouseleave)="changeRemoveIcon(false)"
  (blur)="changeRemoveIcon(false)"
  (mousedown)="changeRemoveIcon(true)"
  (mouseup)="changeRemoveIcon(false)"
>
  <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
  <span> Remove Headers</span>
  <!-- @if(isLoading){
  <span
    class="spinner-border spinner-border-sm mx-2"
    role="status"
    aria-hidden="true"
  ></span>
  } -->
</button>

  <button *ngIf="!isHeaderComponent"
    class="release-btn btn-accello-light"
    (click)="removeParameter()"
    [disabled]="!selectedParameters.length"
    (focus)="changeRemoveIcon(false)"
    (mouseenter)="changeRemoveIcon(false)"
    (mouseleave)="changeRemoveIcon(false)"
    (blur)="changeRemoveIcon(false)"
    (mousedown)="changeRemoveIcon(true)"
    (mouseup)="changeRemoveIcon(false)"
  >
    <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
    <span> Remove Parameters</span>
    <!-- @if(isLoading){
    <span
      class="spinner-border spinner-border-sm mx-2"
      role="status"
      aria-hidden="true"
    ></span>
    } -->
  </button>

</div>

@if(isLoading) {
<app-loading
  class="h-100 w-100 loading-container"
  [text]="'Loading'"
></app-loading>
} @else {

<div class="table-wrapper">
  <app-zorro-table
    tableId="param-tab-view"
    class="w-100 overflow-auto"
    [columns]="columns"
    [data]="rows"
    (handleActions)="handleTableActions($event)"
    (onRowSelect)="handleRowSelection($event)"
  ></app-zorro-table>
</div>
}
